import { FC } from 'react';
import { useSelector } from 'react-redux';

import { recordingsModel } from '../../model';

import { RecordDetailsPrivate } from './record-details-private';
import { RecordDetailsPublic } from './record-details-public';

export const RecordDetails: FC = () => {
  const { isAllowToViewLikeMember } = useSelector(
    recordingsModel.selectors.selectRecord
  );

  if (isAllowToViewLikeMember) {
    return <RecordDetailsPrivate />;
  }

  return <RecordDetailsPublic />;
};
